import React from 'react';
import ModalCadastro from '../_base/modal-cadastro';
import ModalResumoPedido from '../resumo-pedido';
import FormGroupHeader from '../../components/_base/form-group-header';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';

import PedidoFaturamentoComissaoService from '../../services/pedido-faturamento-comissao-service';

// import "./styles.scss";

import lib from '../../helpers/lib';

export default function ModalFaturamentoNota({
  pedidoFaturamentoId,
  showModal,
  setShowModal,
  onClose
}) {
  const [model, setModel] = React.useState({});
  const [viewResumoPedido, setViewResumoPedido] = React.useState(false);
  const [showModalResumo, setShowModalResumo] = React.useState(false);

  React.useEffect(() => {
    if (!pedidoFaturamentoId) return;

    (async () => {
      window.showLoader();
      let response =
        await PedidoFaturamentoComissaoService.getFaturamentoNotaDetalhesAsync(pedidoFaturamentoId);

      setModel(response.data.data);

      window.hideLoader();
    })();
  }, [pedidoFaturamentoId]);

  return (
    <ModalCadastro
      showModal={showModal}
      setShowModal={setShowModal}
      headerText={!viewResumoPedido ? 'NOTA DETALHES' : 'RESUMO DO PEDIDO'}
      // onClose={onClose}
      onClose={() => {
        setViewResumoPedido(false);
      }}
    >
      {!viewResumoPedido ? (
        <div className="modal-body">
          {!model?.pedidoFaturamentoId ? null : (
            <>
              <div>
                <div className="row form-group">
                  <div className="col-lg-2 text-end">
                    <label className="col-form-label">Nº da Nota:</label>
                  </div>

                  <div className="col-lg-8 col-xl-8">
                    <label className="col-form-label">{model.nota}</label>
                  </div>

                  <div className="col-lg-2 col-xl-2 justify-content-end d-flex">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      title="Resumo"
                      onClick={() => {
                        setViewResumoPedido(true);
                        setShowModalResumo(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faFileLines} /> Resumo do Pedido
                    </button>
                  </div>
                </div>

                <div className="row form-group mb-4">
                  <div className="col-lg-2 text-end">
                    <label className="col-form-label">Data da Nota:</label>
                  </div>

                  <div className="col-lg-8 col-xl-5">
                    <label className="col-form-label">
                      {lib.getStringFromDate(model.dataNota)}
                    </label>
                  </div>
                </div>

                <FormGroupHeader text="DADOS DO PEDIDO" />
                <div className="row mb-2">
                  <div className="col-lg-2 text-end">Pedido:</div>
                  <div className="col-lg-4">
                    {model?.codigoPedidoLoja
                      ? model?.codigoPedidoLoja
                      : model?.codigoPedidoRepresentada}
                  </div>
                  <div className="col-lg-2 text-end">Data:</div>
                  <div className="col-lg-4">{lib.getStringFromDateMinute(model?.data)}</div>

                  <div className="col-lg-2 text-end">Tipo:</div>
                  <div className="col-lg-4">{model?.pedidoTipo}</div>

                  {model?.dataMaximaEntrega && (
                    <>
                      <div className="col-lg-2 text-end">Entregar até:</div>
                      <div className="col-lg-4">
                        {lib.getStringFromDate(model.dataMaximaEntrega)}
                      </div>
                    </>
                  )}
                  {model?.prazoPagamento && model?.prazoPagamento != null && (
                    <>
                      <div className="col-lg-2 text-end">Prazo de Pagamento:</div>
                      <div className="col-lg-4">{model.prazoPagamento}</div>
                    </>
                  )}
                  <div className="col-lg-2 text-end">Vendedor:</div>
                  <div className="col-lg-4">{model?.vendedor}</div>
                  {model?.dataAprovacao && model?.dataAprovacao != null && (
                    <>
                      <div className="col-lg-2 text-end">Data Aprovação:</div>
                      <div className="col-lg-4">{lib.getStringFromDate(model.dataAprovacao)}</div>
                      <div className="col-lg-2 text-end">Usuário Aprovação:</div>
                      <div className="col-lg-4">{model.nomeUsuarioAprovacao}</div>
                    </>
                  )}
                  {model?.dataCancelamento && model?.dataCancelamento != null && (
                    <>
                      <div className="col-lg-2 text-end">Data Cancelamento:</div>
                      <div className="col-lg-4">
                        {lib.getStringFromDate(model.dataCancelamento)}
                      </div>
                      <div className="col-lg-2 text-end">Usuário Cancelamento:</div>
                      <div className="col-lg-4">{model.nomeUsuarioCancelamento}</div>
                    </>
                  )}
                </div>

                <FormGroupHeader text="DADOS DA LOJA" />
                <div className="row mb-2">
                  <div className="col-lg-6">
                    <div className="row mb-2">
                      <div className="col-lg-4 text-end">Razão Social:</div>
                      <div className="col-lg-8">{model?.loja?.razaoSocial}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4 text-end">Nome Fantasia:</div>
                      <div className="col-lg-8">{model?.loja?.nomeFantasia}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4 text-end">CNPJ:</div>
                      <div className="col-lg-8">{model?.loja?.cnpj}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4 text-end">Telefone:</div>
                      <div className="col-lg-8">{model?.loja?.contatoTelefone}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4 text-end">Email:</div>
                      <div className="col-lg-8">{model?.loja?.contatoEmail}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4 text-end">Condição Pagamento:</div>
                      <div className="col-lg-8">
                        {model?.loja?.condicaoPagamento != ''
                          ? model?.loja?.condicaoPagamento
                          : '-'}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row mb-2">
                      <div className="col-lg-4 text-end">Endereço:</div>
                      <div className="col-lg-8">
                        {model?.loja?.logradouro}, {model?.loja?.numero}{' '}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4"></div>
                      <div className="col-lg-8">{model?.loja?.bairro}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4"></div>
                      <div className="col-lg-8">
                        {model?.loja?.cidade} - {model?.loja?.estado}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-4"></div>
                      <div className="col-lg-8">{model?.loja?.cep}</div>
                    </div>
                  </div>
                </div>

                <FormGroupHeader text="DADOS DA REPRESENTADA" />
                <div className="row mb-2">
                  <div className="col-lg-9">
                    {model?.representadaRazaoSocial ?? model?.representada?.razaoSocial}
                  </div>
                  <div className="col-lg-3">
                    CNPJ: {model?.representada?.cnpj ?? model?.representada?.cnpj}
                  </div>
                </div>
              </div>

              <FormGroupHeader text="PRODUTOS" />
              <div className="div-table-cadastro">
                <table className="table table-cadastro table-xs">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                      <th className="text-center">Unid. Medida</th>
                      <th className="text-center">Valor Unitário</th>
                      <th className="text-center">Qtd. Faturada</th>
                      <th className="text-center">Total Fatura</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(model?.produtos || []).map((item, index) => (
                      <tr key={index}>
                        <td>{item.codigo}</td>
                        <td>{item.descricao}</td>
                        <td className="text-center">{item.unidade}</td>
                        <td className="text-center">{item.valorUnitarioBrl}</td>
                        <td className="text-center">{item.quantidadeFaturada}</td>
                        <td className="text-center">{item.valorTotalBrl}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={5} align="right">
                        Total:
                      </td>
                      <td className=" text-center">{model?.valorTotalBrl}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      ) : (
        <ModalResumoPedido
          model={model}
          showModal={showModalResumo}
          setShowModal={setShowModalResumo}
        />
      )}
    </ModalCadastro>
  );
}
